/**
 * The ONE web predicate for "is this deal line's COGS estimated?" (UX-5, FLOW-2).
 *
 * It reuses the server's ALREADY-APPLIED verdicts — never a client-side confidence threshold. A line is
 * estimated when either:
 *   - some material group is un-priced (`missing` non-empty — the same fact that hard-blocks release), or
 *   - the server attached its low-confidence release WARNING (`{code:'confidence'}`), which `evaluateRelease`
 *     raises exactly when `confirmed < confFloor` (domain/deal.ts). confFloor is NOT exposed to the web, so
 *     reading that pre-computed warning is the honest way to reflect the same configured bar without
 *     duplicating a threshold literal on the client.
 *
 * Kept in one place so the deal-line mark and the deal-header mark can never disagree.
 */
export interface EstimatableLine {
  /** un-priced material group|unit keys — the hard-block reason at release time */
  missing: string[];
  /** the per-line release-gate PREVIEW; its `warnings` carry the server's `{code:'confidence'}` verdict */
  release?: { warnings?: { code: string }[] } | undefined;
}

export function lineIsEstimated(line: EstimatableLine): boolean {
  return (
    line.missing.length > 0 || (line.release?.warnings ?? []).some((w) => w.code === 'confidence')
  );
}
